import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
};

export const searchCardListNameFilter: SxStyle = {
  flex: 2,
};

export const searchListCardTypeFilter: SxStyle = {
  flex: 1,
};
